import { AlertModal, Button, TextBlock } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./file-sharing.scss";

import testIds from "testIds.json";

const AlertModalWithTestId = AlertModal as React.ComponentType<
    React.ComponentProps<typeof AlertModal> & { testId?: string }
>;

interface Props {
    isOpen: boolean;
    title: string;
    body: string | JSX.Element;
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
    errorMessage?: string;
}

export default function SimpleConfirmationDialog({
    isOpen,
    title,
    body,
    isLoading,
    onClose,
    onConfirm,
    errorMessage,
}: Props): JSX.Element {
    const { t } = useTranslation();

    const content = errorMessage ?? body;
    return (
        <AlertModalWithTestId
            title={title}
            variant="Warning"
            isOpen={isOpen}
            hideModal={onClose}
            className={style.dialog}
            testId={testIds.common.confirmationDialog.itself}
            buttons={
                <>
                    <Button
                        variant="Secondary"
                        onClick={onClose}
                        disabled={isLoading}
                        testId={testIds.common.confirmationDialog.closeButton}
                    >
                        {t("Common.cancel")}
                    </Button>
                    <Button
                        variant="Delete"
                        isLoading={isLoading}
                        testId={testIds.common.confirmationDialog.confirmButton}
                        onClick={onConfirm}
                    >
                        {t("FileSharing.delete.confirm")}
                    </Button>
                </>
            }
        >
            {typeof content === "string" ? <TextBlock>{content}</TextBlock> : content}
        </AlertModalWithTestId>
    );
}
